import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { showToast } from '../../../components/common/notification/Notification';
import PropertyDetailCard from "./PropertyDetailCard";

const PropertySingle = ({backBtn, ownerId: setOwnerId }) => { 
  const { Id } = useParams();
  const [payloadData, setPayloadData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false); 
  const loggedInUser = useSelector((state) => state.auth.user);
  // console.log("loggedInUser", loggedInUser);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;

  const [mediaData, setMediaData] = useState({
    images: [],
    videos: [],
    attachments: [],
  });

  useEffect(() => {
    fetchPropertyItem();
  }, []); 

  const fetchPropertyItem = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}/property/propertyDetail/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('res', response);
      if (response.status === 200) {
        const propertyData = response.data.propertyInfo || {};
        console.log("propertyData", propertyData);
        console.log(propertyData.user.id)
        if (setOwnerId && propertyData.user) {
          console.log("Setting ownerId:", propertyData);
          setOwnerId(propertyData.user.id); 
        }
        setMediaData({
          images: (propertyData.images || []).map((img) => ({
            url: assetUrl + img.image_url,
          })),
          videos: (propertyData.videos || []).map((video) => ({
            url: assetUrl + video.url_path,
          })),
          attachments: (propertyData.attachments || []).map((attachment) => ({
            attachment_url: assetUrl + attachment.attachment_url,
          })),
        });
        // console.log("mediaData", mediaData);

        setPayloadData({ 
            "title": propertyData.name || "",
            "address": propertyData.address || "",
            "land_mark": propertyData.land_mark || "",
            "are": propertyData.are,
            "pin_code": propertyData.pin_code || "",
            "city_name": propertyData.city_name || "",
            "state_name": propertyData.state_name || "",
            "lead_id": propertyData.id || "",
            "country_name": "India",
            "area_name": propertyData.area_name || "",
            "type": propertyData.property_sub_type.property_type_name || null,
            "purpose": propertyData.purpose.name || "", 
            "property_status_id": propertyData.property_status_id || null,
            "sub_type": propertyData.property_sub_type.name || null,
            "sub_sub_type": propertyData.property_sub_sub_type.name || null,
            "active": propertyData.active || false,
            "structure" : { 
              "id": propertyData.structure?.id || null, 
              "bed_rooms": propertyData.structure.bed_rooms || 0,
              "bath_rooms": propertyData.structure.bath_rooms || 0,
              "rooms": propertyData.structure.rooms || 0,
            },
            "feature": {
              "active": propertyData.feature?.active || false,
              "swimming_pool": propertyData.feature?.swimming_pool || false,
              "gas_connection": propertyData.feature?.gas_connection || false,
              "ro": propertyData.feature?.ro || false,
              "club_house": propertyData.feature?.club_house || false,
              "basketball_court": propertyData.feature?.basketball_court || false,
              "tennis_court": propertyData.feature?.tennis_court || false,
              "gym": propertyData.feature?.gym || false,
              "indoor_games": propertyData.feature?.indoor_games || false,
              "child_play_area": propertyData.feature?.child_play_area || false,
              "hospital_near_by": propertyData.feature?.hospital_near_by || false,
              "mall_near_by": propertyData.feature?.mall_near_by || false,
              "market_near_by": propertyData.feature?.market_near_by || false,
              "school_near_by": propertyData.feature?.school_near_by || false,
            },
            "images": mediaData.images || [],
            "videos": mediaData.videos || [],
            "attachments": mediaData.attachments || [],
            "description": propertyData.description || "", 
            "creater": `${propertyData.user.first_name} ${propertyData.user.last_name}` || "",
            "cost": propertyData.price || "",
            "photo": assetUrl + propertyData.user.photo || null, 
            "createdOn": propertyData.feature.created_on || "",
            "isPublished": propertyData.is_published || false,
            "user_type": propertyData.user.userType.name || "",
            "is_address_added": propertyData.user.is_address_added || false,
            "is_become_a_partner": propertyData.user.is_become_a_partner || false,
            "is_email_verified": propertyData.user.is_email_verified || false,
            "is_phone_verified": propertyData.user.is_phone_verified || false,
            "is_whatsapp_number": propertyData.user.is_whatsapp_number || false,
        });
        // console.log("payloadData", payloadData);  
        setIsError(false);
      } else {
        showToast('Failed to fetch property data', { type: 'error' });
      }
    } catch (error) {
      setIsError(true);
      showToast('Error fetching property data', { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };


  return ( 
    <div className="container mb-4">

      <PropertyDetailCard
        name={payloadData.title}
        address={payloadData.address}
        land_mark={payloadData.land_mark}
        area={payloadData.are}
        pin_code={payloadData.pin_code}
        propertyType={payloadData.type}
        city={payloadData.city_name} 
        state={payloadData.state_name}
        country={payloadData.country_name}
        structure={payloadData.structure || {}}
        description={payloadData.description || ""}
        feature={payloadData.feature || {}}
        price={payloadData.cost || ""}
        propertyPurpose={payloadData.purpose} 
        property_sub_type={payloadData.sub_type || ""}
        property_sub_sub_type={payloadData.sub_sub_type || ""}
        images={mediaData.images}
        videos={mediaData.videos}  
        attachments={mediaData.attachments}
        creater={payloadData.creater} 
        photo={payloadData.photo}
        createdOn={payloadData.createdOn}
        isPublished={payloadData.isPublished}
        user_type={payloadData.user_type}
        is_address_added={payloadData.is_address_added}
        is_become_a_partner={payloadData.is_become_a_partner}
        is_email_verified={payloadData.is_email_verified}
        is_phone_verified={payloadData.is_phone_verified}
        is_whatsapp_number={payloadData.is_whatsapp_number}
        isAdmin={loggedInUser.user.userType.name == 'SUPER_ADMIN'} 
       />  
      <Link className="btn btn-sm btn-primary fs-5 px-4 py-2 mt-4" to={backBtn}>
        Back
      </Link>
    </div>

  );
};

export default PropertySingle; 